import type { Messages } from '../messages.js'

/**
 * Indonesian. Shares Malay's alphabet and its lack of plural inflection, and differs in
 * vocabulary: the Dutch borrowings against Malaysian's English ones show up in the wording as
 * clearly as they do in the letter distribution.
 */
export const id: Messages = {
  tag: 'id',

  readingDictionary: 'Membaca kamus…',
  noWordList: 'Tidak ada daftar kata untuk "{language}". Buat satu:  pnpm dictionary build',
  emptyWordList: 'Daftar kata untuk "{language}" kosong.',

  flips: 'balikan',
  score: 'skor',
  words: 'kata',
  round: 'putaran',
  ticksLeftLabel: 'Waktu tersisa di putaran ini',
  typeAWord: 'ketik sebuah kata',
  tapPrompt: 'sentuh untuk ambil atau kembalikan, lalu {action}',

  boardOfTiles: 'Papan {n} kartu',
  faceDown: 'tertutup',
  wildCard: 'kartu liar',
  wildKey: 'huruf apa saja',
  letterReplaced: '{from} menjadi {to}',
  letterSwap: 'GANTI HURUF!',
  spentTile: 'kartu terpakai',
  hiddenWhilePaused: 'disembunyikan saat jeda',
  letterInWord: '{letter}, huruf ke-{position} dari kata',

  completeWord: 'Kirim kata',
  completeShort: 'Kirim',
  reset: 'Hapus',
  pause: 'Jeda',
  resume: 'Lanjutkan',
  newGame: 'Permainan baru',
  paused: 'Dijeda',
  outOfFlips: 'Balikan habis',
  finalResult: '{score} poin dari {words} dalam {rounds}',
  playAgain: 'Main lagi',
  share: 'Bagikan',
  shareCopied: 'Tersalin.',
  shareSelect: 'Salin ini:',

  lettersSelect: 'huruf memilih',
  keysWild: 'diambil saat Anda mengetik huruf yang tidak ditampilkan kartu mana pun',
  clearsEvery: 'menghapus semua {letter} terpilih',
  undoLastLetter: 'membatalkan huruf terakhir',
  noWordsYet: 'Belum ada kata.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'sudah ditemukan',
  reasonTooShort: 'terlalu pendek',
  reasonNotAWord: 'bukan kata',
  reasonAllFound: 'kamu sudah punya semua',
  noSuchLetterUp: 'tidak ada {letter} terbuka',
  nothingUp: 'tidak ada yang terbuka',
  letterHidden: 'sebuah huruf bersembunyi',
  shuffled: 'diacak',
  shuffledAndBilled: 'diacak, {flips} balikan tak terpakai ditagih',
  tooFewLetters: 'Huruf yang tersisa terlalu sedikit',

  gameLanguage: 'bahasa',
  interfaceLanguage: 'antarmuka',
  dictionarySize: '{common} umum dari {full} kata',
  filterLanguages: 'Cari bahasa',
  noMatches: 'Tidak ada hasil',

  nerdMode: 'mode rinci',
  rules: 'Aturan',
  difficulty: 'kesulitan',
  difficultyNames: { easy: 'mudah', medium: 'sedang', hard: 'sulit', insane: 'brutal' },
  pausedNoBoard: 'Permainan ini tidak akan masuk papan peringkat.',
  about: 'Tentang',
  themeLabel: 'tema',
  themeNames: { traditional: 'tradisional', light: 'terang', contrast: 'kontras tinggi' },
  tiles: 'kartu (N)',
  secondsPerTick: 'detik / ketukan',
  holdTicks: 'ketukan tahan',
  minWord: 'kata terpendek',
  startingFlips: 'balikan awal',
  wildChance: 'peluang kartu liar',
  replaceChance: 'peluang penggantian huruf',
  hideChance: 'peluang huruf disembunyikan',
  wordCompleteMode: 'kata selesai',
  wordCompleteNames: { shuffle: 'acak', spend: 'pakai', keep: 'simpan' },
  flipEconomy: 'ekonomi balikan',
  flipEconomyNames: {
    none: 'tidak ada',
    perLetter: 'per huruf',
    fibonacci: 'fibonacci',
    overMinimum: 'di atas minimum',
  },
  repeatedLetterKey: 'tombol huruf berulang',
  keySchemeNames: { cycle: 'putar', advance: 'maju' },
  keySchemeHelp: {
    cycle:
      'A mengambil A bebas berikutnya, dan begitu semuanya ada dalam kata, ia menghapusnya. ' +
      'Shift+A juga menghapusnya.',
    advance: 'A mengambil A bebas berikutnya. Shift+A menghapus setiap A dari kata.',
  },

  whatThatMeans: 'Apa artinya',
  factRound: 'satu putaran',
  factWholeBoardUp: 'seluruh papan terbuka',
  factRoundCosts: 'satu putaran memakan',
  factFlipsBuy: 'balikan awal memberi',
  factThisBoard: 'papan ini',
  factBoardHadToAdmit: 'papan harus mengizinkan',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, terpanjang {longest}',
  wordsIncludingOneOf: '{words} termasuk satu dari {ceiling}',
  scorelessRounds: '{rounds} tanpa poin',

  whatAWordPays: 'Hasil sebuah kata',
  columnLetters: 'huruf',
  columnCost: 'biaya',
  columnPoints: 'poin',
  columnFlips: 'balikan',
  columnNet: 'neto',

  canonicalRules: 'Aturan {difficulty} resmi.',
  customRules: 'Diubah dari praatur. Skor dengan aturan sendiri tidak diperingkat.',
  applyAndStart: 'Terapkan dan mulai permainan baru',
  changesNextGame: 'Perubahan berlaku pada permainan berikutnya.',
  presets: 'Praatur:',

  start: 'Mulai',
  restart: 'Mulai ulang',
  quit: 'Keluar',
  quitTitle: 'Keluar dari permainan ini?',
  restartTitle: 'Mulai ulang permainan ini?',
  restartConfirm: 'Mulai ulang',
  quitConfirm: 'Keluar',
  keepPlaying: 'Lanjut bermain',
  personalBest: 'Permainan terbaik Anda',
  newPersonalBest: 'Rekor pribadi baru.',
  columnRank: '#',
  notRanked: 'Aturan sendiri, jadi permainan ini tidak diperingkat.',
  notRankedPaused: 'Waktu berhenti, jadi permainan ini tidak diperingkat.',
  rankOfTotal: '{rank} dari {total}',

  howToPlay: 'Cara bermain',

  backToGame: 'Kembali ke permainan',
  welcomeTitle: 'Selamat datang di Blinkered',
  tutorialSkip: 'Lewati',
  tutorialNext: 'Berikutnya',
  tutorialBack: 'Kembali',
  tutorialStart: 'Mulai bermain',
  tutorialHideAgain: 'Jangan tampilkan lagi',
  tutorialProgress: '{n} dari {total}',
  tutorialSkipTitle: 'Lewati pengenalan?',
  tutGoalTitle: 'Blinkered adalah perlombaan',
  tutGoalBody:
    'Anda memulai permainan dengan jumlah balikan yang tetap, dan setiap kartu yang berbalik memakan satu balikan. Ketika balikan habis, permainan berakhir. Menyusun kata menghasilkan balikan, dan makin panjang katanya, makin banyak balikan yang Anda dapat.',
  tutSpentBody:
    'Huruf yang Anda pakai dalam kata tertutup sampai putaran berikutnya. Hanya pergantian huruf yang mengubah huruf apa saja yang ada di papan.',
  tutChangeTitle: 'Huruf dapat berubah',
  tutSameLetters:
    'Melihat kata yang belum sempat Anda mainkan? Huruf yang sama kembali di putaran berikutnya, diacak ke tempat baru.',
  tutPickLetters: 'Ketuk huruf yang Anda inginkan secara berurutan untuk menyusun kata.',
  tutMoreTurn:
    'Ubin terus terbuka selagi Anda berpikir, jadi huruf yang lebih baik mungkin masih datang.',
  tutTapBack:
    'Salah ketuk? Ketuk lagi untuk mengembalikannya. Huruf mana pun, bukan hanya yang terakhir.',
  tutComplete: 'Tekan Selesai saat kata sudah siap.',
  htBoardTitle: 'Papan',
  htBoardBody:
    'Kartu dibuka satu per satu, dalam urutan acak. Dari kartu yang terbuka Anda menyusun kata.',
  htWordsTitle: 'Kata',
  htWordsBody:
    'Susun kata dari kartu yang terbuka dengan mengetik atau mengeklik hurufnya secara berurutan.',
  htFlipsTitle: 'Balikan',
  htFlipsBody:
    'Setiap kartu yang berbalik memakan satu balikan. Kata yang selesai menambahkan balikan ke jumlah Anda, dan kata yang panjang memberi lebih banyak. Ketika balikan habis, permainan berakhir.',
  htRoundTitle: 'Putaran',
  htRoundBody:
    'Ketika kartu terakhir suatu putaran berbalik, seluruh papan terbuka sesaat. Lalu kartu dibalik tertutup dan diacak, dan putaran baru dimulai.',
  htLanguagesTitle: 'Bahasa',
  htLanguagesBody:
    '{n}. Setiap papan bisa diselesaikan dengan kata yang benar-benar dipakai. Kata yang tidak umum tetap dihitung, jika kamus mengenalnya.',
  htKeysTitle: 'Papan tik',
  htWildTitle: 'Kartu liar',
  htWildBody:
    'Kadang muncul kartu liar, bukan huruf. Kartu liar berlaku sebagai huruf apa pun yang membentuk kata yang sah. Kata yang sudah selesai tidak dihitung.',
  htHideTitle: 'Huruf yang bersembunyi',
  htHideBody:
    'Pada level yang lebih sulit, huruf yang terbuka dapat menutup sendiri dan kembali nanti dalam ronde itu. Pengatur waktu mendapat satu tik tambahan untuk itu, berwarna merah. Huruf yang sudah dipilih tidak menutup.',
  tutHideBody:
    'Pada level yang lebih sulit, huruf yang terbuka dapat menutup sendiri dan kembali nanti dalam ronde itu. Huruf yang sudah dipilih tidak menutup.',
  htSwapTitle: 'Huruf yang berubah',
  htSwapBody:
    'Kadang, di antara putaran, satu huruf diganti dengan huruf lain. Anda akan melihat huruf mana yang dihapus dan mana yang ditambahkan.',
  htLevelsTitle: 'Tingkat kesulitan',
  htLevelEasy:
    'Dua belas huruf yang sama sepanjang permainan, jadi Anda bisa menghafalnya dan menyimpan daftar kata di kepala. Kartu terbuka perlahan dan papan penuh tetap terlihat cukup lama untuk selesai memilih huruf Anda.',
  htLevelMedium:
    'Sesekali satu huruf berubah, sehingga lebih sulit mengingat kata yang ingin Anda mainkan nanti. Lebih sedikit waktu untuk melihat dan berpikir.',
  htLevelHard:
    'Kata tiga huruf tidak lagi dihitung, dan satu huruf berubah kira-kira setiap dua ronde. Papan baru saja terlihat sebelum diacak lagi.',
  htLevelInsane:
    'Semuanya sekaligus, dengan kecepatan penuh. Papan diacak hampir segera setelah balikan terakhir.',
  htTouchTitle: 'Layar sentuh',
  htTouchBody:
    'Sentuh kartu yang terbuka untuk mengambil hurufnya. Sentuh huruf mana pun yang sudah diambil untuk mengembalikannya. Kirim dan Hapus ada di bawah papan.',

  accountTitle: 'Akun kamu',
  menuProfile: 'Profil saya',
  menuGames: 'Permainan saya',
  menuPublicPage: 'Halaman publik saya',
  menuSignedInAs: 'Masuk sebagai',
  signIn: 'Masuk',
  signOut: 'Keluar',
  signInTitle: 'Masuk atau daftar',
  signInLead: 'Akun menyimpan permainanmu, di setiap perangkat.',
  signInKeepGame: 'Masuk untuk menyimpan permainan ini, dan semua setelahnya.',
  continueWithApple: 'Lanjutkan dengan Apple',
  continueWithGoogle: 'Lanjutkan dengan Google',
  signInOr: 'atau',
  emailLabel: 'Email',
  codeLabel: 'Kode',
  emailMeACode: 'Kirimi saya kode',
  working: 'Sebentar…',
  sendNewCode: 'Kirim kode baru',
  codeSent: 'Cek emailmu. Kode berlaku 10 menit.',
  notNow: 'Nanti saja',
  badEmail: 'Ini tidak terlihat seperti alamat email.',
  badCode: 'Kode itu tidak cocok. Kode kedaluwarsa setelah 10 menit dan sekali pakai.',
  serverBusy: 'Tidak bisa menghubungi server. Coba lagi sebentar lagi.',
  serverDown: 'Tidak bisa menghubungi server.',
  offline: 'Offline',
  leaderboardTitle: 'Papan Peringkat',
  leaderboardEmpty: 'Belum ada permainan di papan ini. Jadilah yang pertama.',
  leaderboardWouldBe: 'Di mana permainan ini akan berada',
  leaderboardThisGame: 'Permainan ini',
  leaderboardRanksHere: 'Di mana permainan ini berada',
  leaderboardOutside: 'Di luar lima besar.',
  tutAccountTitle: 'Simpan skormu',
  tutAccountBody:
    'Akun menyimpan permainanmu, menempatkan skormu di papan peringkat, dan menjaga profilmu.',
  ssoCancelled: 'Masuk dibatalkan.',
  ssoExpired: 'Terlalu lama. Masuk lagi.',
  ssoNoUsername: 'Pembuatan akun tidak selesai. Coba lagi sebentar lagi.',
  ssoFailed: 'Tidak berhasil. Coba lagi, atau pakai emailmu.',
  tabProfile: 'Profil',
  countryAny: 'Tidak bilang',
  findCountry: 'Cari negara',
  usernameLabel: 'Nama pengguna',
  bioLabel: 'Tentang saya',
  countryLabel: 'Negara',
  bioHint: 'Tanpa tautan. {left}/{max}',
  save: 'Simpan',
  saving: 'Menyimpan…',
  saved: 'Tersimpan.',
  nameTaken: 'Nama itu sudah dipakai.',
  nameTooShort: 'Agak panjangan sedikit.',
  nameTooLong: 'Terlalu panjang.',
  nameBadCharacters: 'Hanya huruf, angka, tanda hubung, dan garis bawah.',
  nameBadEdges: 'Harus diawali dan diakhiri huruf atau angka.',
  nameMixedScripts: 'Pilih satu aksara dan tetap di situ.',
  nameReserved: 'Ini mirip nama yang kami bagikan sendiri. Pilih yang lain.',
  nameUnusable: 'Nama itu tidak bisa dipakai.',
  bioTooLong: 'Tentang saya paling banyak {max} karakter.',
  bioHasLink: 'Tautan tidak boleh ada di sini.',
  bioHasControl: 'Ada karakter yang tidak bisa dimuat di sini.',
  bioUnusable: 'Teks itu tidak bisa dipakai.',
  gamesHeading: 'Permainan',
  gamesEmpty:
    'Belum ada apa-apa di sini. Permainan yang kamu mainkan sambil masuk akan muncul di sini.',
  gamesEmptyShort: 'Belum ada apa-apa di sini.',
  gamesLoading: 'Membaca permainanmu…',
  theirGamesLoading: 'Membaca permainan mereka…',
  profileLoading: 'Membaca profil…',
  playerNotFound: 'Tidak ada siapa pun di sini dengan nama itu.',
  columnWhen: 'Kapan',
  columnRounds: 'putaran',
  columnGame: 'Permainan',
  gameLoading: 'Membaca permainan…',
  gameUnreadable: 'Permainan ini tidak bisa dibaca.',
  gameNotRanked: 'Dimainkan dengan aturan yang diubah, jadi tidak masuk peringkat.',
  detailNotKept: 'Kata dan papan permainan ini tidak disimpan lagi.',
  openingBoard: 'Papan pembuka',
  roundByRound: 'Ronde demi ronde',
  roundNothing: 'tidak ada yang ketemu',
  changeReplaced: '{letter} diganti di kotak {slot}',
  changeWildOn: '{letter} jadi joker di kotak {slot}',
  changeWildOff: '{letter} joker hilang dari kotak {slot}',
  keepThisGame: 'Simpan permainan ini',
  savedToYourGames: 'Tersimpan di permainanmu.',

  reportThis: 'Laporkan',
  reportHeading: 'Laporkan ini',
  reportTheName: 'Namanya',
  reportTheBio: 'Bionya',
  reportTheScore: 'Skornya',
  reportWhy: 'Apa yang salah dengannya? Opsional.',
  reportSend: 'Kirim laporan',
  reportSent: 'Terima kasih. Seseorang akan memeriksanya.',
  reportSignIn: 'Masuk untuk melaporkan sesuatu.',
  reportGone: 'Itu sudah tidak ada.',
  reportCancel: 'Batal',

  deleteAccount: 'Hapus akun saya',
  deleteAccountWhat:
    'Ini menghapus profilmu dan setiap permainan yang kamu simpan, selamanya. Tidak bisa dibatalkan.',
  deleteAccountAsk: 'Kirimi saya kode',
  deleteConfirm: 'Hapus selamanya',
  deleteGone: 'Akunmu sudah hilang. Terima kasih sudah bermain.',
  deleteNoAddress:
    'Tidak ada alamat terkonfirmasi di akun ini, jadi penghapusan tidak bisa diperiksa. Hubungi kami dan kami lakukan manual.',

  rulesetFacts: 'Kata {letters} · kartu baru setiap {seconds}',
  plurals: {
    words: { other: '{n} kata' },
    rounds: { other: '{n} putaran' },
    flips: { other: '{n} balikan' },
    ticks: { other: '{n} ketukan' },
    points: { other: '{n} poin' },
    minLetters: { other: 'minimal {n} huruf' },
    seconds: { other: '{n} detik' },
  },
}
